import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * Custom `tailwind-merge` instance that knows about our Snoots typography
 * utilities defined in `styles/globals.css` (`text-headline-*`, `text-body-*`,
 * `text-label-*`). Without this, tailwind-merge treats them as unknown
 * `text-*` classes and deduplicates them against text-colour utilities like
 * `text-foreground`, silently dropping the font-size/weight styling.
 *
 * Note: `text-headline-*` utilities also set `text-transform: uppercase` as
 * a baked-in style. tailwind-merge only reasons about class-level conflicts,
 * not the CSS properties inside a class - so if you ever need to override
 * with `normal-case`/`lowercase`, use the `!` important marker to guarantee
 * cascade order (e.g. `text-headline-sm !normal-case`).
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'headline-lg',
            'headline-lg-mobile',
            'headline-md',
            'headline-sm',
            'body-lg',
            'body-md',
            'label-md',
            'label-sm',
            'fine-print',
            'button',
            'button-sm',
          ],
        },
      ],
    },
  },
})

/** Merges Tailwind class names, resolving conflicts via tailwind-merge. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
